import { useEffect, useState } from "react";
import { useAiEventStreamLifecycle } from "./useAiEventStream.ts";

function useAiChatReasoningStatus(triggerStatusRead: number = 0) {
  const { hasStreamStarted, hasStreamEnded } = useAiEventStreamLifecycle();

  const [indicatorType, setIndicatorType] = useState<"loading" | "alert" | null>(null);

  useEffect(() => {
    if (hasStreamEnded) {
      setIndicatorType("alert");
      return;
    }
    if (hasStreamStarted) {
      setIndicatorType("loading");
      return;
    }
  }, [hasStreamStarted, hasStreamEnded, triggerStatusRead]);

  return {
    indicatorType,
    setIndicatorType,
  };
}

export default useAiChatReasoningStatus;
